import { AUTH_BASE_URL } from "../constants/constants";
import { sendRequest } from "../utils/sendAPI";
import { getToken } from "./authApi";

export const getProfile = async () => {
  try {
    const token = getToken();
    if (!token) throw new Error("Token missing or expired");

    const res = await sendRequest({
      url: `${AUTH_BASE_URL}/authentication/me`,
      method: "GET",
      token: token,
    });
    return res;
  } catch (err) {
    console.error("Error fetching user profile:", err);
    throw err;
  }
};

export const getProfileBookings = async ({ page, size }) => {
  try {
    const token = getToken();
    if (!token) throw new Error("Token missing or expired");

    const params = new URLSearchParams({
      page: page,
      size: size,
    });

    const res = await sendRequest({
      url: `${AUTH_BASE_URL}/authentication/me/bookings?${params.toString()}`,
      method: "GET",
      token: token,
    });

    return res;
  } catch (err) {
    console.error("Error fetching booking:", err);
    throw err;
  }
};

export const cancelBooking = async ({ id }) => {
  try {
    const token = getToken();
    if (!token) throw new Error("Token missing or expired");

    const res = await sendRequest({
      url: `${AUTH_BASE_URL}/authentication/me/booking/${id}/cancel`,
      method: "PATCH",
      token: token,
    });

    return res;
  } catch (err) {
    console.error("Error cancel booking:", err);
    throw err;
  }
};
